import React from "react";
import styled from "styled-components";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import { gtagReportConversion } from "../modules/utils";
import { GTM_EMAIL_EVENT, GTM_PHONE_CALL_EVENT } from "../modules/constants";
import { Container } from "./Container";

const FooterContainer = styled.footer`
  padding: 34px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(11, 12, 18, 0.52);
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 18px;
  align-items: start;

  @media screen and (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

const Title = styled.h3`
  color: var(--text-0);
  font-size: 16px;
  letter-spacing: 0.02em;
  margin-bottom: 12px;
`;

const LinkList = styled.div`
  display: grid;
  gap: 10px;
`;

const LinkRow = styled.a`
  text-decoration: none;
  color: var(--text-0);
  display: inline-flex;
  align-items: center;
  gap: 10px;

  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: var(--surface-0);

  transition:
    transform 160ms ease,
    background 160ms ease,
    border-color 160ms ease;

  &:hover {
    transform: translateY(-1px);
    background: var(--surface-1);
    border-color: rgba(255, 255, 255, 0.18);
  }

  &:active {
    transform: translateY(0px);
  }
`;

const LinkText = styled.span`
  color: rgba(255, 255, 255, 0.82);
  font-weight: 700;
`;

const FinePrint = styled.div`
  display: grid;
  gap: 6px;
  justify-items: end;
  text-align: right;
  color: rgba(255, 255, 255, 0.6);

  @media screen and (max-width: 860px) {
    justify-items: start;
    text-align: left;
  }
`;

const FineLine = styled.p`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
`;

export const Footer = () => {
  return (
    <FooterContainer>
      <Container>
        <FooterGrid>
          <div>
            <Title>Contact</Title>
            <LinkList>
              <LinkRow
                href="mailto:nate.paulemon@auxiliaryone.io"
                target="__blank"
                onClick={() => gtagReportConversion(undefined, GTM_EMAIL_EVENT)}
              >
                <MailIcon fontSize="small" />
                <LinkText>nate.paulemon@auxiliaryone.io</LinkText>
              </LinkRow>
              <LinkRow
                href="tel:+2038205307"
                target="__blank"
                onClick={() =>
                  gtagReportConversion(undefined, GTM_PHONE_CALL_EVENT)
                }
              >
                <PhoneIcon fontSize="small" />
                <LinkText>+1-203-820-5307</LinkText>
              </LinkRow>
            </LinkList>
          </div>

          <FinePrint>
            <FineLine>
              &copy; {new Date().getFullYear()} Auxiliary One LLC
            </FineLine>
            <FineLine>All rights reserved.</FineLine>
          </FinePrint>
        </FooterGrid>
      </Container>
    </FooterContainer>
  );
};
